import { Link } from "react-router-dom";
import { useOfficialTerms } from "../../lib/officialTerms";

/** Section « Sécurité et pointage » — résumé des règles officielles (Registre maître). */
export const SafetyScoringSection = ({ compact = false }) => {
  const T = useOfficialTerms();
  const lines = (T.safety_message || "").split("\n").filter(Boolean);
  return (
    <section className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-5" data-testid="safety-scoring-section">
      <div className="text-[10px] tracking-[0.3em] text-emerald-300 mb-2">SÉCURITÉ ET POINTAGE</div>
      <h3 className="text-base md:text-lg font-bold text-zinc-100">{T.event_tagline}</h3>
      <p className="text-zinc-400 text-sm mt-1">{T.event_tagline_sub}</p>
      <ul className="mt-3 space-y-1.5 text-sm text-zinc-300">
        {lines.slice(0, compact ? 2 : lines.length).map((l, i) => <li key={i} className="flex gap-2"><span className="text-emerald-400">•</span><span>{l}</span></li>)}
      </ul>
      {T.bjj_public_text && !compact && <p className="text-zinc-400 text-xs mt-3 italic">{T.bjj_public_text}</p>}
      <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
        <Link to="/reglement-securite" className="text-emerald-300 underline underline-offset-2" data-testid="safety-rules-link">Règlement de développement compétitif et de sécurité →</Link>
        <Link to="/fqjjb" className="text-emerald-300 underline underline-offset-2" data-testid="safety-fqjjb-link">Tableau maître FQJJB (Jiu-Jitsu) →</Link>
        <span className="text-zinc-500">{T.rules_format_note}</span>
      </div>
    </section>
  );
};
